// extracted by mini-css-extract-plugin
module.exports = {"resumeItem":"_3uWp67id_5DQAyBPx_88J1","resumeItemDate":"_3rld1QkGXgir1HZsb0PIOJ","resumeItemList":"_2nCaWqyJFsf4zS-sccrseQ"};